'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { Fragment } from 'react';
import { Divider } from '~/components/Divider';
import styles from './AccommodationCard.module.css';
import { type AccommodationCheckInOutDetails, CHECK_IN_ICON_SRC, CHECK_OUT_ICON_SRC } from './AccommodationCard.types';
import { ItineraryCard } from './ItineraryCard';
type CheckRowProps = {
  iconSrc: string;
  text: string;
};
const CheckRow = t0 => {
  const $ = _c(7);
  const {
    iconSrc,
    text
  } = t0;
  let t1;
  if ($[0] !== iconSrc) {
    t1 = <span className={styles.checkRowIconWrap} aria-hidden={true}><Image src={iconSrc} alt="" width={22} height={22} className={styles.checkRowIcon} /></span>;
    $[0] = iconSrc;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== text) {
    t2 = <span className={styles.checkRowText}>{text}</span>;
    $[2] = text;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={styles.checkRow}>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
type AccommodationCheckInOutSectionProps = {
  details: AccommodationCheckInOutDetails;
};
export function AccommodationCheckInOutSection(t0) {
  const $ = _c(26);
  const {
    details
  } = t0;
  const t = useTranslations("journey");
  const {
    variant,
    checkInNoEarlierThan,
    checkInValue,
    checkOutValue
  } = details;
  const isTimesVariant = variant === "times";
  let rows;
  if ($[0] !== checkInValue || $[1] !== checkOutValue || $[2] !== isTimesVariant || $[3] !== t) {
    rows = [];
    if (checkInValue) {
      let t1;
      if ($[5] !== checkInValue || $[6] !== isTimesVariant || $[7] !== t) {
        t1 = isTimesVariant ? t("accommodation_check_in_after", {
          time: checkInValue
        }) : t("accommodation_check_in_on", {
          date: checkInValue
        });
        $[5] = checkInValue;
        $[6] = isTimesVariant;
        $[7] = t;
        $[8] = t1;
      } else {
        t1 = $[8];
      }
      let t2;
      if ($[9] !== t1) {
        t2 = {
          iconSrc: CHECK_IN_ICON_SRC,
          text: t1
        };
        $[9] = t1;
        $[10] = t2;
      } else {
        t2 = $[10];
      }
      rows.push(t2);
    }
    if (checkOutValue) {
      let t1;
      if ($[11] !== checkOutValue || $[12] !== isTimesVariant || $[13] !== t) {
        t1 = isTimesVariant ? t("accommodation_check_out_before", {
          time: checkOutValue
        }) : t("accommodation_check_out_on", {
          date: checkOutValue
        });
        $[11] = checkOutValue;
        $[12] = isTimesVariant;
        $[13] = t;
        $[14] = t1;
      } else {
        t1 = $[14];
      }
      let t2;
      if ($[15] !== t1) {
        t2 = {
          iconSrc: CHECK_OUT_ICON_SRC,
          text: t1
        };
        $[15] = t1;
        $[16] = t2;
      } else {
        t2 = $[16];
      }
      rows.push(t2);
    }
    $[0] = checkInValue;
    $[1] = checkOutValue;
    $[2] = isTimesVariant;
    $[3] = t;
    $[4] = rows;
  } else {
    rows = $[4];
  }
  let t1;
  if ($[17] !== checkInNoEarlierThan || $[18] !== isTimesVariant || $[19] !== t) {
    t1 = isTimesVariant && checkInNoEarlierThan ? <ItineraryCard.InfoBanner>{t("accommodation_check_in_no_earlier", {
        time: checkInNoEarlierThan
      })}</ItineraryCard.InfoBanner> : null;
    $[17] = checkInNoEarlierThan;
    $[18] = isTimesVariant;
    $[19] = t;
    $[20] = t1;
  } else {
    t1 = $[20];
  }
  let t2;
  if ($[21] !== rows) {
    t2 = rows.length > 0 ? <div className={styles.checkInOut}>{rows.map(_temp)}</div> : null;
    $[21] = rows;
    $[22] = t2;
  } else {
    t2 = $[22];
  }
  let t3;
  if ($[23] !== t1 || $[24] !== t2) {
    t3 = <div className={styles.checkInSection}>{t1}{t2}</div>;
    $[23] = t1;
    $[24] = t2;
    $[25] = t3;
  } else {
    t3 = $[25];
  }
  return t3;
}
function _temp(row, index) {
  return <Fragment key={row.iconSrc}>{index > 0 ? <Divider variant="horizontal" /> : null}<CheckRow iconSrc={row.iconSrc} text={row.text} /></Fragment>;
}